<template>
  <div class="app-main-content">
    <div id="open-price-final" class="grid-view">
      <div class="main-content">
        <search-item
          ref="searchItem"
          config-module="225300"
          :expand-adv="true"
          :show-simple="false"
          :custom-search-items="customSearchItems"
          @advSearchItemCallBack="queryHandler"
        >
          <div slot="operations" />
        </search-item>
        <div class="section grid-wrapper" style="position: relative">
          <cargo-ag-grid-wrapper
            config-module="225300"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            :show-selected-color="false"
            :check-sub-record="false"
            style="height: 100%;"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            config-module="225300"
            :total="filter.total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="fetchDataByPage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import ColumnUtils from '@/utils/ColumnUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { queryFinalList, getDataMapping } from '@/api/price/openPrice'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { deepClone } from '@/utils'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'

export default {
  name: 'OpenPriceFinal',
  components: { cargoAgGridWrapper, searchItem },
  data() {
    return {
      SystemConstants,
      loading: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        context: {
          componentParent: this
        },
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.selectedRows = this.gridApi.getSelectedRows()
        },
        // 行点击触发事件
        onRowClicked: (event) => { this.selectedRow = event.data },
        onRowDoubleClicked: this.onRowDoubleClickedHandler
      },
      rowData: [],
      selectedRows: [],
      selectedRow: null,
      gridApi: null,
      customSearchItems: [], // 自定义高级查询项
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 20
      },
      abcs: [{ code: 'A' }, { code: 'B' }, { code: 'C' }], // ABC
      companyCodes: [], // 公司代码
      lanes: [], // 航线
      eqSizes: SeaExportConstants.SEA_EXPORT_BOX_TYPES, // 尺码
      departureDays: SystemConstants.WEEKS, // 周班
      eqTypes: [], // 箱型
      cargoTypes: [], // 货种
      seaports: [], // 海港
      currentOfficeMappingCode: '' // 当前用户分公司代码
    }
  },
  computed: {
    columnDefs() {
      return [
        // {
        //   headerName: '', width: 55, checkboxSelection: true,
        //   sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        //   headerCheckboxSelection: true
        // },
        {
          headerName: this.$t('CargoMsg.Cargo_FilingBatchNo'), colId: 'filingBatchNo', field: 'filingBatchNo', initialWidth: 140, minWidth: 140
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FilingDate'), colId: 'filingDate', field: 'filingDate', initialWidth: 130, minWidth: 130,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EffectiveDate'), colId: 'effectiveDate', field: 'effectiveDate', initialWidth: 130, minWidth: 130,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CompanyCode2'), colId: 'companyCode', field: 'companyCode', initialWidth: 100, minWidth: 100,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Lane'), colId: 'lane', field: 'lane', initialWidth: 120, minWidth: 120,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DepartureDay'), field: 'departureDay', colId: 'departureDay', initialWidth: 100, minWidth: 100,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          valueFormatter: (params) => {
            return !params.value ? '' : ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.WEEKS)
          }
        },
        {
          headerName: 'ABC', colId: 'abc', field: 'abc', initialWidth: 80, minWidth: 80,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_StartingPort'), colId: 'pol', field: 'pol', initialWidth: 120, minWidth: 120,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_POD'), colId: 'pod', field: 'pod', initialWidth: 120, minWidth: 120,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ContainerSize'), colId: 'eqType', field: 'eqType', initialWidth: 80, minWidth: 80,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CargoType2'), colId: 'cargoType', field: 'cargoType', initialWidth: 80, minWidth: 80,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EqSize'), colId: 'eqSize', field: 'eqSize', initialWidth: 80, minWidth: 80,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Cost2'), colId: 'cost', field: 'cost', initialWidth: 100, minWidth: 100,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            return !params.value ? '' : this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CostMin'), colId: 'costMin', field: 'costMin', initialWidth: 100, minWidth: 100,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            return !params.value ? '' : this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CostMax'), colId: 'costMax', field: 'costMax', initialWidth: 100, minWidth: 100,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            return !params.value ? '' : this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Commission'), colId: 'commission', field: 'commission', initialWidth: 80, minWidth: 80,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.value) {
              return ''
            }
            return !params.value ? '' : this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EqDeduct'), colId: 'eqDeduct', field: 'eqDeduct', initialWidth: 80, minWidth: 80,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            return !params.value ? '' : this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: 'BAF', colId: 'baf', field: 'baf', initialWidth: 80, minWidth: 80,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            return !params.value ? '' : this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: 'CAF', colId: 'caf', field: 'caf', initialWidth: 80, minWidth: 80,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            return !params.value ? '' : this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OtherSurcharge'), colId: 'otherSurcharge', field: 'otherSurcharge', initialWidth: 120, minWidth: 120,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            return !params.value ? '' : this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: 'O.THC', colId: 'othc', field: 'othc', initialWidth: 80, minWidth: 80,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            return !params.value ? '' : this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: 'D.THC', colId: 'dthc', field: 'dthc', initialWidth: 80, minWidth: 80,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            return !params.value ? '' : this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Remarks'), colId: 'remarks', field: 'remarks', initialWidth: 150, minWidth: 150,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          }
        }
      ]
    }
  },
  async created() {
    await this.initGridSpareData()
    await this.initDataMapping()
    this.customSearchItems = await this.getCustomSearchItems()
  },
  methods: {
    // 航交所数据映射
    async initDataMapping() {
      await getDataMapping().then(res => {
        if (res && res.data) {
          const dataMapping = res.data
          // 分公司代码
          const companyCodeMappings = dataMapping.companyCodes || []
          if (companyCodeMappings.length > 0 && this.companyCodes.length > 0) {
            for (const mapping of companyCodeMappings) {
              for (const item of this.companyCodes) {
                if (mapping.sourceValue === item.code) {
                  if (item.code === this.$store.getters.currentOffice.code) {
                    this.currentOfficeMappingCode = mapping.targetValue
                  }
                  item.code = mapping.targetValue
                  break
                }
              }
            }
          }
          // 航线
          const laneMappings = dataMapping.lanes || []
          if (laneMappings.length > 0 && this.lanes.length > 0) {
            for (const mapping of laneMappings) {
              for (const item of this.lanes) {
                if (mapping.sourceValue === item.code) {
                  item.code = String(mapping.targetValue)
                  break
                }
              }
            }
          }
          // 箱型
          const eqTypeMappings = dataMapping.eqTypes || []
          if (eqTypeMappings.length > 0 && this.eqTypes.length > 0) {
            for (const mapping of eqTypeMappings) {
              for (const item of this.eqTypes) {
                if (mapping.sourceValue === item.code) {
                  item.code = mapping.targetValue
                  break
                }
              }
            }
          }
          // 箱尺寸
          const eqSizeMappings = dataMapping.eqSizes || []
          if (eqSizeMappings.length > 0 && this.eqSizes.length > 0) {
            for (const mapping of eqSizeMappings) {
              for (const item of this.eqSizes) {
                if (mapping.sourceValue === item.code) {
                  item.code = mapping.targetValue
                  break
                }
              }
            }
          }
          // 货物类型
          const cargoTypeMappings = dataMapping.cargoTypes || []
          if (cargoTypeMappings.length > 0 && this.cargoTypes.length > 0) {
            for (const mapping of cargoTypeMappings) {
              for (const item of this.cargoTypes) {
                if (mapping.sourceValue === item.code) {
                  item.code = mapping.targetValue
                  break
                }
              }
            }
          }
          // 海港
          const seaportMappings = dataMapping.seaports || []
          if (seaportMappings.length > 0 && this.seaports.length > 0) {
            for (const mapping of seaportMappings) {
              for (const item of this.seaports) {
                if (mapping.sourceValue === item.code) {
                  item.code = mapping.targetValue
                  break
                }
              }
            }
          }
        }
      })
    },
    // 表格下拉等数据
    async initGridSpareData() {
      // 公司代码
      this.companyCodes = deepClone(await getCacheListByKey(basicCacheKeys.basic_data_Office_All))
      // 航线
      this.lanes = deepClone(getCacheListByKey(basicCacheKeys.basic_data_Region))
      // 箱型
      this.eqTypes = deepClone(getCacheListByKey(basicCacheKeys.basic_data_EQType))
      // 货物类型
      this.cargoTypes = deepClone(getCacheListByKey(basicCacheKeys.basic_data_CargoType))
      this.cargoTypes = this.cargoTypes.filter(p => p.sea === true) // 海运
      // 海港
      this.seaports = deepClone(getCacheListByKey(basicCacheKeys.basic_data_Seaport))

      await this.loadSearchItems()
    },
    // 组装查询条件
    async getCustomSearchItems() {
      const defaultSearchFields = []
      // 公司代码
      defaultSearchFields.push(this.createSearchFieldMulti(this.companyCodes, 'price.COMPANY_CODE', 'CargoMsg.Cargo_CompanyCode2'))
      // 航线
      defaultSearchFields.push(this.createSearchFieldMulti(this.lanes, 'price.LANE', 'CargoMsg.Cargo_Lane'))
      // 起始港
      defaultSearchFields.push(this.createSearchFieldMulti(this.seaports, 'price.POL', 'CargoMsg.Cargo_StartingPort'))
      // 目的港
      defaultSearchFields.push(this.createSearchFieldMulti(this.seaports, 'price.POD', 'CargoMsg.Cargo_POD'))
      // 箱型
      defaultSearchFields.push(this.createSearchFieldMulti(this.eqTypes, 'price.EQ_TYPE', 'CargoMsg.Cargo_ContainerSize'))
      // 货种
      defaultSearchFields.push(this.createSearchFieldMulti(this.cargoTypes, 'price.CARGO_TYPE', 'CargoMsg.Cargo_CargoType2'))
      // 尺码
      defaultSearchFields.push(this.createSearchFieldMulti(this.eqSizes, 'price.EQ_SIZE', 'CargoMsg.Cargo_EqSize'))
      // 运价区间
      const searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'input'
      searchField.subType = 'bigdecimalrangeWithPrecision'
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_POSITIVE_NUMBER_RANGE'
      searchField.itemName = 'price.COST'
      searchField.itemLabel = 'CargoMsg.Cargo_CostRange'
      searchField.itemValue = ''
      searchField.defaultSelected = 1
      searchField.selected = 1
      searchField.valueExpression = ''
      searchField.lock = false
      searchField.defaultValue = ''
      defaultSearchFields.push(searchField.formatObj2Json())

      return defaultSearchFields
    },
    createSearchFieldMulti(data, itemName, itemLabel, itemType = 'advanceSelect2', tagName = 'code', tagValue = 'code') {
      const searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = itemType
      searchField.multiple = 1
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = itemName
      searchField.itemLabel = itemLabel
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 1
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = data
      searchField.tagName = tagName
      searchField.tagValue = tagValue
      searchField.filterType = 'global'
      searchField.filterTagNames = ['code', 'englishName', 'chineseName']

      return searchField.formatObj2Json()
    },
    async loadSearchItems() {
      const office = this.$store.getters.currentOffice
      if (office.code === 'HQ') {
        // 总部用户，显示所有分公司代码
        this.companyCodes = this.companyCodes.filter(p => p.code !== 'HQ').sort((office1, office2) => office1.officeId > office2.officeId ? 1 : -1)
      } else {
        // 非总部用户，显示所属分公司
        this.companyCodes = this.companyCodes.filter(p => p.officeId === office.officeId)
      }
    },
    // 分页触发查询
    fetchDataByPage() {
      this.queryHandler(this.filter.conditions)
    },
    onRowDoubleClickedHandler(event) {
      this.selectedRow = event.data
    },
    queryHandler(data) {
      if (data) {
        // 分公司
        if (!AdvancedSearchOption.hasField('price.COMPANY_CODE', data) && this.$store.getters.currentOffice.code !== 'HQ') {
          if (!this.currentOfficeMappingCode || this.currentOfficeMappingCode.length === 0) {
            this.currentOfficeMappingCode = this.$store.getters.currentOffice.code
          }
          data.push(new AdvancedSearchOption(null, 'price.COMPANY_CODE', [this.currentOfficeMappingCode], AdvancedSearchConsts.OPERATOR_IN.code).formatObj2Json())
        }
        this.filter.conditions = data
      }
      this.loading = getLoading4Cxt()
      this.filter.branchId = this.$store.getters.currentOfficeId
      queryFinalList(this.filter).then(res => {
        this.handleQueryData(res)
      }).finally(() => {
        this.loading.close()
      })
    },
    handleQueryData(res) {
      const curSelected = [] // this.gridApi.getSelectedRows().map(item => item.uuid)
      this.rowData = res.data.list
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.filter.total = Number(res.data.total)
      this.selectedRow = null
      this.selectedRows = []
      //
      if (this.gridApi) this.gridApi.clearFocusedCell()
      if (curSelected.length) {
        this.$nextTick(() => {
          this.gridOptions.api.forEachNode(node => {
            if (node.data && node.data.uuid && curSelected.find((id) => id === node.data.uuid)) {
              node.setSelected(true)
            }
          })
        })
      }
    }
  }
}
</script>

<style lang="scss">
#app #open-price-final {
  .cargo-button-group-slider {
    height: 20px;
  }
  .el-select__tags {
    flex-wrap: nowrap;
    span {
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-left: 8px;
      font-size: 12px;
      height: 14px;
      color: #606266;
      &>span{
        padding-left: 0;
        padding-right: 5px;
      }
    }
  }
}
</style>
